import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Injectable()
export class UrlParamService {

  constructor(
    private readonly activatedRoute: ActivatedRoute,
  ) {
  }

  getWbaFormVersion() {
    return this.activatedRoute.snapshot.queryParams.v;
  }

  getWbaAntragId() {
    return this.activatedRoute.snapshot.queryParams.id;
  }
}
